(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Alwan", [], factory);
	else if(typeof exports === 'object')
		exports["Alwan"] = factory();
	else
		root["Alwan"] = factory();
})(self, function() {
return 